// extracted by mini-css-extract-plugin
export var cardIcon = "_8r-5";
export var cardIconUnframed = "_8r-9";
export var checkboxCard = "_8r-0";
export var checkboxCardSelected = "_8r-4";
export var disabled = "_8r-2";
export var interactive = "_8r-1";
export var outerBorder = "_8r-3";
export var spacerMedium = "_8r-8";
export var spacerSmall = "_8r-7";
export var spacerXsmall = "_8r-6";